import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { capitalize } from '@shared/utils/strings';

@Pipe({ name: 'capitalize' })
export class CapitalizePipe implements PipeTransform {
    transform(value: string | string[]): any {
        if (!value) {
            return value;
        }

        if (Array.isArray(value)) {
            return value.map(v => capitalize(v));
        }

        return capitalize(value);
    }
}
